import { SeatmapConfig, SeatmapUtils } from "../..";
import { PriceLevel, Promotion } from "webshop-api";
import {
    Block,
    CssClassCallbacks,
    GeneralAdmission,
    RenderOptions,
    Seat,
    SeatmapClient,
    Type
} from "@eventim/seatmap-client";
import { ArrayHelper } from "webshop-modules/helper/Array.helper";

export class SeatmapDataFactory {
    public static setupAPIConnectorFrom(config: SeatmapConfig): string {
        return `${config.connectorType}-${config.connectorId}-${config.eventId}`
    }

    public static getPriceCategoryIdsForInitialFilterFrom(priceLevels: PriceLevel[], promotion: Promotion | null): number[] {
        if (promotion && promotion.id) {
            return SeatmapUtils.getPriceLevelsWithHoldsFor(promotion.id, priceLevels)
                .map(priceLevel => priceLevel.priceLevelId)
                .filter(ArrayHelper.isDefined);
        }

        const priceLevelIds = SeatmapUtils.getPriceLevelsWithDefaultPromotionHoldFrom(priceLevels)
            .map(priceLevel => priceLevel.priceLevelId)
            .filter(ArrayHelper.isDefined);

        return priceLevelIds.length ? priceLevelIds : [-1];
    }

    public static assignCssClasses(client: SeatmapClient): CssClassCallbacks {
        return {
            seatClasses: (seat: Seat) => {
                if (client.isSelected(client.getElementIdByType(seat.id, Type.SEAT))) {
                    return ['o-seatmapSelection__selectedSeat']
                }

                return seat.excluded || !seat.available ? [] : ['o-seatmapSelection__availableSeat'];
            },
            gaClasses: (ga: GeneralAdmission) => {
                if (client.isSelected(client.getElementIdByType(ga.id, Type.GENERAL_ADMISSION))) {
                    return ['o-seatmapSelection__ga', 'o-seatmapSelection__selectedGa', 'o-seatmapSelection__availableGa'];
                }

                return ga.excluded || !ga.available ? ['o-seatmapSelection__ga'] : ['o-seatmapSelection__ga', 'o-seatmapSelection__availableGa'];
            },
            blockOutlineClasses: (blockOutline: Block) => ['o-seatmapSelection__blockOutline'],
            linkedBlockClasses: (linkedBlock: Block) => linkedBlock.excluded ? ['o-seatmapSelection__block'] : ['o-seatmapSelection__availableBlock', 'o-seatmapSelection__block'],
        }
    }

    public static setupAdditionalParamsFrom(config, token: string) {
        return {
            a_TDLToken: token,
            a_SystemID: config.systemId,
            a_PromotionID: config.promotionId,
        }
    }

    public static setupRenderOptionsFor(client: SeatmapClient): RenderOptions {
        return {
            seats: [10, 1000],
            rows: [0, 10],
            zoomControls: false,
            backButton: false,
            cssClassCallbacks: SeatmapDataFactory.assignCssClasses(client),
        }
    }
}
